export const FIELDS = {

  ID: 'id',
  INSPECTION_REPORT_TYPE_ID: 'inspectionReportTypeId',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  SALES_ORDER_LINE_ID: 'salesOrderLineId',
  RMA_LINE_ID: 'rmaLineId',
  PO_LINE_ID: 'poLineId',
  SO_LINE_ID: 'soLineId',
  DATE_INSPECTED: 'dateInspected',
  INSPECTED_BY_USER_ID: 'inspectedByUserId',
  STATUS_ID: 'statusId',
  INVENTORY_ID: 'inventoryId',
  ORDERED: 'ordered',
  ORDER_DETAIL__SHIPPING_PAY_METHOD: 'orderDetailShippingPayMethod',
  ORDER_DETAIL__CODAMOUNT: 'orderDetailCodAmount',
  PRODUCT_DETAILS__RECEIVED: 'productDetailsReceived',
  PRODUCT_DETAILS__STOCK: 'productDetailsStock',
  PRODUCT_DETAILS__OTHER: 'productDetailsOther',
  PRODUCT_DETAILS__MARKING: 'productDetailsMarking',
  PRODUCT_DETAILS__LOCATION: 'productDetailsLocation',
  PRODUCT_DETAILS__BREAKDOWN: 'productDetailsBreakdown',
  SHIPMENT_DETAILS__NUMBER_BOXES: 'shipmentDetailsNumberBoxes',
  SHIPMENT_DETAILS__CONDITION: 'shipmentDetailsCondition',
  SHIPMENT_DETAILS__SHIPPED_IN: 'shipmentDetailsShippedIn',
  SHIPMENT_DETAILS__SHIPPED_IN_OTHER: 'shipmentDetailsShippedInOther',
  SHIPMENT_DETAILS__DAMAGED: 'shipmentDetailsDamaged',
  SHIPMENT_DETAILS__NOTES: 'shipmentDetailsNotes',
  PACKAGING__ORIGINAL_PACKAGING: 'packagingOriginalPackaging',
  PACKAGING__SEALED_BAGS: 'packagingSealedBags',
  PACKAGING__FACTORY_VACUUM_BAGS: 'packagingFactoryVacuumBags',
  PACKAGING__FACTORY_LABEL: 'packagingFactoryLabel',
  PACKAGING__HOLES_IN_BAG: 'packagingHolesInBag',
  PACKAGING__PACKAGE_IN_GOOD_COND: 'packagingPackageInGoodCond',
  PACKAGING__SURFACE_SANDING: 'packagingSurfaceSanding',
  PACKAGING__CLEAR_PN: 'packagingClearPn',
  PACKAGING__SAME_PN: 'packagingSamePn',
  PACKAGING__MARKED_OR_PRINTED: 'packagingMarkedOrPrinted',
  SURFACE__MAG_INSPECT: 'surfaceMagInspect',
  SURFACE__TEST_DOTS: 'surfaceTestDots',
  SURFACE__VISIBLE_DIRT: 'surfaceVisibleDirt',
  SURFACE__VISIBLE_DUST: 'surfaceVisibleDust',
  SURFACE__IMPROPER_HANDLING: 'surfaceImproperHandling',
  SURFACE__CONSISTENT_DCLC: 'surfaceConsistentDclc',
  SURFACE__SAME_ORIGIN: 'surfaceSameOrigin',
  SURFACE__CLEAR_MFR_LOGO: 'surfaceClearMfrLogo',
  SURFACE__CRACKS_SCRATCH: 'surfaceCracksScratch',
  SURFACE__SAME_SURFACES: 'surfaceSameSurfaces',
  SURFACE__TOP_BOTTOM_MARKINGS: 'surfaceTopBottomMarkings',
  SURFACE__SAME_PIN_INDICATOR: 'surfaceSamePinIndicator',
  SURFACE__PHOTOS_TAKEN: 'surfacePhotosTaken',
  LEAD_VERIFICATION__STRAIGHT_LEADS: 'leadVerificationStraightLeads',
  LEAD_VERIFICATION__USED_LEADS: 'leadVerificationUsedLeads',
  LEAD_VERIFICATION__DIRTY_LEADS: 'leadVerificationDirtyLeads',
  LEAD_VERIFICATION__PIN_DAMAGE: 'leadVerificationPinDamage',
  LEAD_VERIFICATION__VISIBLE_SOLDER: 'leadVerificationVisibleSolder',
  LEAD_VERIFICATION__PHYSICAL_PACKAGE: 'leadVerificationPhysicalPackage',
  QCMGMT__BLANK_PROGRAM_CHECK: 'qcMgmtBlankProgramCheck',
  QCMGMT__BPCRESULTS: 'qcMgmtBpcResults',
  QCMGMT__XRAY: 'qcMgmtXRay',
  QCMGMT__XRAY_RESULTS: 'qcMgmtXRayResults',
  QCMGMT__CHEM_TEST: 'qcMgmtChemTest',
  QCMGMT__CHEM_TEST_RESULTS: 'qcMgmtChemTestResults',
  PART_ACCEPTANCE__ACCEPTED_OR_REJECTED: 'partAcceptanceAcceptedOrRejected',
  PART_ACCEPTANCE__QTY_ACCEPTED: 'partAcceptanceQtyAccepted',
  PART_ACCEPTANCE__QTY_REJECTED: 'partAcceptanceQtyRejected',
  PART_ACCEPTANCE__NOTES: 'partAcceptanceNotes',
  INITIAL_INSPECTION__PODATA_MATCH: 'initialInspectionPoDataMatch',
  INITIAL_INSPECTION__FACTORY_LABEL: 'initialInspectionFactoryLabel',
  INITIAL_INSPECTION__LABEL_LOGO: 'initialInspectionLabelLogo',
  INITIAL_INSPECTION__CONSISTENT_CODES: 'initialInspectionConsistentCodes',
  INITIAL_INSPECTION__DCAGREEMENT: 'initialInspectionDcAgreement',
  INITIAL_INSPECTION__PACKAGING_DAMAGE: 'initialInspectionPackagingDamage',
  INITIAL_INSPECTION__DAMAGE_NOTES: 'initialInspectionDamageNotes',
  GENERAL_CARTON_INSPECTION__PRODUCT_WEIGHT: 'generalCartonInspectionProductWeight',
  GENERAL_CARTON_INSPECTION__OUTER_PACKAGE_DAMAGE: 'generalCartonInspectionOuterPackageDamage',
  GENERAL_CARTON_INSPECTION__PHOTO_DAMAGE: 'generalCartonInspectionPhotoDamage',
  GENERAL_CARTON_INSPECTION__SEALING_TAPE: 'generalCartonInspectionSealingTape',
  GENERAL_CARTON_INSPECTION__PACKAGE_CLAIM: 'generalCartonInspectionPackageClaim',
  OUTER_CARTON_INSPECTION__PHOTO_LABELS: 'outerCartonInspectionPhotoLabels',
  OUTER_CARTON_INSPECTION__OUTER_SEALING_TAPE: 'outerCartonInspectionOuterSealingTape',
  OUTER_CARTON_INSPECTION__INSPECT_LABELS: 'outerCartonInspectionInspectLabels',
  OUTER_CARTON_INSPECTION__READABLE_BARCODE: 'outerCartonInspectionReadableBarcode',
  INNER_CONTENT_INSPECTION__INNER_CONTENTS: 'innerContentInspectionInnerContents',
  INNER_CONTENT_INSPECTION__BAG_SEAL: 'innerContentInspectionBagSeal',
  INNER_CONTENT_INSPECTION__COMPARE_LABELS: 'innerContentInspectionCompareLabels',
  INNER_CONTENT_INSPECTION__SEAL_DATE: 'innerContentInspectionSealDate',
  INNER_CONTENT_INSPECTION__MSLLEVEL: 'innerContentInspectionMslLevel',
  INNER_CONTENT_INSPECTION__ESDCOMPLIANT: 'innerContentInspectionEsdCompliant',
  TRAY_INSPECTION__EXPECTED_COLOR: 'trayInspectionExpectedColor',
  TRAY_INSPECTION__PRE_PRINTED_MARKINGS: 'trayInspectionPrePrintedMarkings',
  TRAY_INSPECTION__ORIENTED: 'trayInspectionOriented',
  TRAY_INSPECTION__TOP_TRAY: 'trayInspectionTopTray',
  TRAY_INSPECTION__ANTI_STATIC_COVER: 'trayInspectionAntiStaticCover',
  TRAY_INSPECTION__CHIP_ORIENTATION: 'trayInspectionChipOrientation',
  TUBE_INSPECTION__TUBE_DIRECTION: 'tubeInspectionTubeDirection',
  TUBE_INSPECTION__IMPRINTED_LOGO: 'tubeInspectionImprintedLogo',
  TUBE_INSPECTION__TUBE_CONDITION: 'tubeInspectionTubeCondition',
  TUBE_INSPECTION__TUBE_QTY: 'tubeInspectionTubeQty',
  TUBE_INSPECTION__TUBE_STOPPERS: 'tubeInspectionTubeStoppers',
  REEL_INSPECTION__LABELS: 'reelInspectionLabels',
  REEL_INSPECTION__SIZE: 'reelInspectionSize',
  REEL_INSPECTION__LEADER_TAPE: 'reelInspectionLeaderTape',
  REEL_INSPECTION__COUNT: 'reelInspectionCount',
  REEL_INSPECTION__ORIENTATION: 'reelInspectionOrientation',
  REEL_INSPECTION__DAMAGE: 'reelInspectionDamage',
  BULK_INSPECTION__COUNT: 'bulkInspectionCount',
  BULK_INSPECTION__BAG: 'bulkInspectionBag',
  BULK_INSPECTION__BAG_MARKINGS: 'bulkInspectionBagMarkings',
  BULK_INSPECTION__DATE_CODES: 'bulkInspectionDateCodes',
  DETAIL_INSPECTION__LOGO: 'detailInspectionLogo',
  DETAIL_INSPECTION__MARKINGS: 'detailInspectionMarkings',
  DETAIL_INSPECTION__MARKING_TOP_BOTTOM: 'detailInspectionMarkingTopBottom',
  DETAIL_INSPECTION__LASER_MARKS: 'detailInspectionLaserMarks',
  DETAIL_INSPECTION__SIZE: 'detailInspectionSize',
  DETAIL_INSPECTION__BURNS: 'detailInspectionBurns',
  DETAIL_INSPECTION__DOTS: 'detailInspectionDots',
  DETAIL_INSPECTION__FLUX: 'detailInspectionFLux',
  DETAIL_INSPECTION__CRACKS: 'detailInspectionCracks',
  DETAIL_INSPECTION__PIN_COUNT: 'detailInspectionPinCount',
  DETAIL_INSPECTION__TERMINAL: 'detailInspectionTerminal',
  DETAIL_INSPECTION__LEADS: 'detailInspectionLeads',
  DETAIL_INSPECTION__OXIDATION: 'detailInspectionOxidation',
  DETAIL_INSPECTION__SUSPECT_PART: 'detailInspectionSuspectPart',
  DETAIL_INSPECTION__SCRATCHES: 'detailInspectionScratches',
  DETAIL_INSPECTION__BGA: 'detailInspectionBga',
  DETAIL_INSPECTION__PHOTO: 'detailInspectionPhoto',
  SOLVENT_INSPECTION__MARKING_TEST_DETAIL: 'solventInspectionMarkingTestDetail',
  SOLVENT_INSPECTION__SURFACE_TEST_DETAIL: 'solventInspectionSurfaceTestDetail',
  SOLVENT_INSPECTION__SCRAPE_TEST_DETAIL: 'solventInspectionScrapeTestDetail',
  MECHANICAL_INSPECTION__TOLERANCE: 'mechanicalInspectionTolerance',
  MECHANICAL_INSPECTION__DIMENSIONS: 'mechanicalInspectionDimensions',
  MECHANICAL_INSPECTION__THICKNESS_VARIATION: 'mechanicalInspectionThicknessVariation',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  ACTIVE: 'active',
  INSPECTION_REPORT_TYPE_NAME: 'inspectionReportTypeName',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PODATE: 'poDate',
  VENDOR_ID: 'vendorId',
  VENDOR_NAME: 'vendorName',
  VENDOR_CONTACT_ID: 'vendorContactId',
  VENDOR_CONTACT_FULL_NAME: 'vendorContactFullName',
  CUSTOMER_ID: 'customerId',
  CUSTOMER_NAME: 'customerName',
  CUSTOMER_CONTACT_ID: 'customerContactId',
  SALES_PERSON_USER_ID: 'salesPersonUserId',
  SALES_PERSON_USER_FULL_NAME: 'salesPersonUserFullName',
  QUANTITY_SOLD: 'quantitySold',
  INSPECTED_BY_USER_FULL_NAME: 'inspectedByUserFullName',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  SKU: 'sku',
  DESCRIPTION: 'description',
  MANUFACTURER_ID: 'manufacturerId',
  MFG_NAME: 'mfgName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  PHYS_PKG: 'physPkg',
  LEAD_FREE: 'leadFree',
  UO_MID: 'uoMId',
  UOM: 'uom',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  CONDITION_ID: 'conditionId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
};